module.exports = "<h2>Class Declarations</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">class Book {\n    var name: String\n    var author: String?\n\n    constructor(name: String, author: String?) {\n        this.name = name\n        this.author = author\n    }\n}</code></pre><h3 class=\"fragment\">Primary Constructor</h3><pre class=\"fragment\"><code class=\"lang-kotlin\">class Book(var name: String,\n           var author: String)</code></pre><h4 class=\"fragment\">Final by default, add 'open' to allow extension</h4>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/02.pug
// module id = 324
// module chunks = 1